<!-- 赞助详情 -->
<template>
  <div class="sponsorDet">
    <v-head :bg="'#272727'"></v-head>
    <div class="detail-container">
      <div class="top-container">
        <div class="top-bread">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/parttime' }">兼职</el-breadcrumb-item>
            <el-breadcrumb-item>{{ titlecast }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <div class="content-wrap">
        <div class="content-wrap-l">
          <div class="content-comp-info-top">
            <h3>{{ data_list.post_title }}</h3>
            <span class="com-info-type">{{ data_list.money }}</span>
            <div class="part-info">
              <span>{{ data_list.work_area }}</span>
              <span>{{ data_list.genter }}</span>
              <span>{{ data_list.post_number }}</span>
            </div>
            <p>{{ data_list.fb_msg }}</p>
          </div>
          <div class="parttime-content">
            <div class="parttime-item">
              <h4>工作时间</h4>
              <div class="parttime-item-detail">{{ data_list.work_time }}</div>
            </div>
            <div class="parttime-item">
              <h4>岗位职责</h4>
              <div class="parttime-item-detail">
                <p v-for="(item,index) of data_list.duties" :key="index">{{ index + 1 }}、{{ item }}</p>
              </div>
            </div>
            <div class="parttime-item">
              <h4>职位要求</h4>
              <div class="parttime-item-detail">
                <p v-for="(item,index) of data_list.claim" :key="index">{{ index + 1 }}、{{ item }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="content-wrap-r">
          <div class="comp-info">
            <img
              src="https://devpic.nauac.com/20190815/07167d9f5d0b4ca88b9669a9cbc784ba.jpg"
              class="comp-logo"
              alt
            />
            <div class="comp-title">
              <h4>{{ data_list.recruitment_comp }}</h4>
              <span class="status-tag">{{ data_list.status_tag }}</span>
            </div>
          </div>
          <ul class="info-list-ul">
            <li>
              <span class="icon icon-nature"></span>
              <span class="info-title">单位性质：</span>
              <span>{{ data_list.nature }}</span>
            </li>
            <li>
              <span class="icon icon-area"></span>
              <span class="info-title">单位区域：</span>
              <span>{{ data_list.area }}</span>
            </li>
          </ul>
          <p>{{ data_list.intro }}</p>
        </div>
      </div>
    </div>
    <!-- footer -->
    <v-footer></v-footer>
  </div>
</template>
<script>
import vHead from '@/components/header/header.vue'
import vFooter from '@/components/footer/footer.vue'
import {
  Breadcrumb,
  BreadcrumbItem
} from 'element-ui'
export default {
  data () {
    return {
      idcast: this.$route.query.id,
      titlecast: this.$route.query.title,
      list: [{
        post_title: '文都教育考研校园代理',
        genter: '男女不限',
        post_number: '招若干人',
        fb_msg: '2019-07-21 发布于校园精准服务',
        work_area: '北京-丰台区',
        work_time: '每周四天',
        recruitment_comp: '世纪文都教育科技集团股份有限公司',
        status_tag: '已认证',
        nature: '国企',
        money: '面议',
        area: '北京市',
        duties: ['负责销售文都教育线上考研课程', '帮助学生体验网上教学带来的便利性，进行校园网络资源推广', '对网上操作不熟练的学生，协助购物听课操作'],
        claim: ['想在学习期间自主创业，喜欢销售及网络营销，能吃苦耐劳，有一定的抗压能力，愿积极投入社会实践工作的学生', '在学校内有自己的人际关系网络，并有良好的理解能力与表达能力，沟通能力', '对考研、电子商务及网络课程有一定了解', '有极其方便的上网环境，有自己的笔记本', '校内BBS版主、社团负责人、或者市场营销相关工作经验者优先考虑'],
        intro: '广东触电传媒科技有限公司于2014年04月23日成立。法定代表人林勤生,公司经营范围包括市场营销策划服务;群众参与的文艺类演出、比赛等公益性文化活动的策划;体育营销策划服可文化娱零售线广播电视传输服音'
      }, {
        post_title: '专业英语翻译实习生',
        genter: '女',
        post_number: '1人',
        fb_msg: '2019-07-21 发布于校园精准服务',
        work_area: '浙江-宁波鄞州',
        work_time: '每周五天',
        recruitment_comp: '世纪文都教育科技集团股份有限公司',
        status_tag: '已认证',
        nature: '国企',
        money: '面议',
        area: '北京市',
        duties: ['负责英语业务的翻译', '接受主管分配的翻译任务', '保证翻译质量', '翻译资料的整理收集、知识管理', '翻译并与团队成员沟通协作'],
        claim: ['在校生，本科及以上学历，英语相关专业优先，CET-6高分或高分通过TEM-4，能够无障碍地阅读国外网站', '会使用Google搜索、Google map', '具有较好的沟通表达能力和学习能力', '积极乐观，具有良好的团队协作精神', '外语听说能力良好，笔译功底深厚，精通中外互译，中文文笔优秀'],
        intro: '公司经营范围包括市场营销策划服务;群众参与的文艺类演出、比赛等公益性文化活动的策划;体育营销策划服可文化娱零售线广播电视传输服音'
      }, {
        post_title: '星巴克直招六日学生兼职服务员',
        genter: '男女不限',
        post_number: '5人',
        fb_msg: '2019-07-21 发布于校园精准服务',
        work_area: '上海市',
        work_time: '每周两天',
        recruitment_comp: '上海颢淼展览展示服务有限公司',
        status_tag: '已认证',
        nature: '国企',
        money: '面议',
        area: '上海市',
        duties: ['咖啡厅兼职服务人员', '周六日或周一到周五，每天工作5-6个小时. 可根据个人的时间安排上班时'],
        claim: ['在校生，本科及以上学历', '吃苦耐劳.工作认真,沟通能力好', '有良好服务态度.服从公司安排。(服务态度必须要好)', '表现好的可开出实践证明'],
        intro: '公司经营范围包括市场营销策划服务;群众参与的文艺类演出、比赛等公益性文化活动的策划;体育营销策划服可文化娱零售线广播电视传输服音'
      }],
      data_list: {}
    }
  },
  created () {
    // 移动端适配最小高度为浏览器高度
    this.$nextTick(() => {
      let containerDom = document.getElementsByClassName('container')[0]
      if (containerDom) {
        containerDom.style.minHeight = (document.documentElement.clientHeight - 100) + 'px'
      }
    })
  },
  mounted () {
    this.data_list = this.list[this.idcast]
  },
  components: {
    'v-head': vHead,
    'v-footer': vFooter,
    'el-breadcrumb': Breadcrumb,
    'el-breadcrumb-item': BreadcrumbItem
  },
  methods: {

  }
}
</script>
<style src='../sponsor-det/sponsor-det-native.scss' lang='scss' scoped></style>
<style src='./parttimedetail.scss' lang='scss' scoped></style>



// WEBPACK FOOTER //
// src/views/parttime/parttimedetail.vue